import React, { useState } from "react";
import { authFetch } from "../../../../api/api"; 


const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;
const API_URL = `${BASE_URL}/api/accounting/currencies/`;

const empty = { symbol: "", code: "", name: "" };

export default function CurrenciesTab({ currencies, setCurrencies }) {
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [error, setError] = useState("");



  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const cancelEdit = () => {
    setEditingId(null);
    setForm(empty);
    setError("");
  };

  const saveRow = async () => {
    setError("");
    const payload = {
      symbol: form.symbol.trim(),
      code: form.code.trim().toUpperCase(),
      name: form.name.trim(),
    };
    if (!payload.code || !payload.name) {
      setError("Код и название обязательны");
      return;
    }

    try {
      const url = editingId ? `${API_URL}${editingId}/` : API_URL;
      const method = editingId ? "PATCH" : "POST";
      const res = await authFetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        // code уникален — покажем ошибку DRF
        if (data.code) setError(`Код: ${data.code.join(", ")}`);
        else if (data.detail) setError(data.detail);
        else setError("Ошибка сохранения");
        return;
      }

      if (editingId) {
        setCurrencies((prev) => prev.map((c) => (c.id === data.id ? data : c)));
        setEditingId(null);
      } else {
        setCurrencies((prev) => [...prev, data]);
      }
      setForm(empty);
    } catch (e) {
      setError(e.message);
    }
  };

  const editRow = (row) => {
    setEditingId(row.id);
    setForm({ symbol: row.symbol, code: row.code, name: row.name });
    setError("");
  };

  const askDelete = (row) => {
    setRowToDelete(row);
    setShowDeleteConfirm(true);
  };

  const confirmDelete = async () => {
    if (!rowToDelete) return;
    setError("");
    try {
      const res = await authFetch(`${API_URL}${rowToDelete.id}/`, {
        method: "DELETE",
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(
          res.status === 400
            ? "Нельзя удалить: валюта используется в платежах"
            : data.detail || "Ошибка удаления"
        );
        setShowDeleteConfirm(false);
        setRowToDelete(null);
        return;
      }
      setCurrencies((prev) => prev.filter((c) => c.id !== rowToDelete.id));
      setShowDeleteConfirm(false);
      setRowToDelete(null);
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <div>
      {error && (
        <div className="mb-3 p-2 bg-red-100 text-red-700 rounded text-sm">
          {error}
        </div>
      )}

      <table className="border-collapse border w-full text-sm">
        <thead>
          <tr className="bg-gray-100">
            <th className="border p-2">Символ</th>
            <th className="border p-2">Код</th>
            <th className="border p-2">Название</th>
            <th className="border p-2">Действия</th>
          </tr>
        </thead>
        <tbody>
          {currencies.length === 0 && (
            <tr>
              <td colSpan={4} className="border p-4 text-center text-gray-500">
                Валют пока нет — добавьте первую ниже
              </td>
            </tr>
          )}

          {currencies.map((row) => (
            <tr key={row.id}>
              <td className="border p-2">
                {editingId === row.id ? (
                  <input
                    className="w-full border rounded px-2 py-1"
                    value={form.symbol}
                    onChange={(e) => handleChange("symbol", e.target.value)}
                  />
                ) : (
                  row.symbol
                )}
              </td>
              <td className="border p-2">
                {editingId === row.id ? (
                  <input
                    className="w-full border rounded px-2 py-1"
                    value={form.code}
                    onChange={(e) => handleChange("code", e.target.value)}
                  />
                ) : (
                  row.code
                )}
              </td>
              <td className="border p-2">
                {editingId === row.id ? (
                  <input
                    className="w-full border rounded px-2 py-1"
                    value={form.name}
                    onChange={(e) => handleChange("name", e.target.value)}
                  />
                ) : (
                  row.name
                )}
              </td>
              <td className="border p-2">
                {editingId === row.id ? (
                  <>
                    <button className="text-blue-600 mr-3" onClick={saveRow}>
                      Сохранить
                    </button>
                    <button className="text-gray-600" onClick={cancelEdit}>
                      Отмена
                    </button>
                  </>
                ) : (
                  <>
                    <button className="text-blue-600 mr-3" onClick={() => editRow(row)}>
                      Редактировать
                    </button>
                    <button className="text-red-600" onClick={() => askDelete(row)}>
                      Удалить
                    </button>
                  </>
                )}
              </td>
            </tr>
          ))}

          {editingId === null && (
            <tr>
              <td className="border p-1">
                <input
                  className="w-full border rounded px-2 py-1"
                  placeholder="₽"
                  value={form.symbol}
                  onChange={(e) => handleChange("symbol", e.target.value)}
                />
              </td>
              <td className="border p-1">
                <input
                  className="w-full border rounded px-2 py-1"
                  placeholder="RUB"
                  value={form.code}
                  onChange={(e) => handleChange("code", e.target.value)}
                />
              </td>
              <td className="border p-1">
                <input
                  className="w-full border rounded px-2 py-1"
                  placeholder="Российский рубль"
                  value={form.name}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
              </td>
              <td className="border p-1">
                <button
                  className="bg-blue-600 text-white px-3 py-1 rounded"
                  onClick={saveRow}
                >
                  Добавить
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-96">
            <h3 className="text-lg font-bold mb-4">Удалить валюту?</h3>
            <p className="mb-6 text-gray-600">
              {rowToDelete?.symbol} {rowToDelete?.code} — {rowToDelete?.name}
            </p>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 border rounded"
                onClick={() => {
                  setShowDeleteConfirm(false);
                  setRowToDelete(null);
                }}
              >
                Отмена
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded"
                onClick={confirmDelete}
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}